import { render, staticRenderFns } from "./OnlineLearningLoginLayout.vue?vue&type=template&id=d536b66a&"
import script from "./OnlineLearningLoginLayout.vue?vue&type=script&lang=js&"
export * from "./OnlineLearningLoginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d536b66a')) {
      api.createRecord('d536b66a', component.options)
    } else {
      api.reload('d536b66a', component.options)
    }
    module.hot.accept("./OnlineLearningLoginLayout.vue?vue&type=template&id=d536b66a&", function () {
      api.rerender('d536b66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/OnlineLearningLoginLayout.vue"
export default component.exports